<template>
  <a-card :bordered="false">
    <a-row :gutter="24" style="margin-bottom: 2vh;">
      <a-col :md="9" :sm="24" style="margin-bottom: 2vh;">
        <a-input-search v-model="query.deviceName" placeholder="输入终端名称进行搜索" enterButton @search="fetchData"/>
      </a-col>
    </a-row>

    <a-list
      :loading="loading"
      :grid="{ gutter: 16, xs: 1, sm: 2, md: 4, lg: 4, xl: 4, xxl:6 }"
      :dataSource="page.content"
      :pagination="pagination">
      <a-list-item slot="renderItem" slot-scope="item">
        <a-card hoverable>
          <template class="ant-card-actions" slot="actions">
            {{ item.mac ? item.mac : 'N/A' }}
          </template>
          <a-card-meta>
            <a-avatar slot="avatar" :src="icoUrl" />
            <template slot="title">
              {{ item.name }} <a-icon type="edit" class="edit-name" @click="handleEdit(item)"/>
            </template>
            <template slot="description">
              <div :style="{ color: item.isActive ? 'green' : 'red' }">
                状态：{{ item.isActive ? '正常' : '未激活' }}
              </div>
            </template>
          </a-card-meta>
        </a-card>
      </a-list-item>
    </a-list>

    <a-modal
      :visible="visible"
      :maskClosable="false"
      :confirmLoading="confirmLoading"
      title="修改终端名称"
      @ok="handleOk"
      @cancel="visible = false">
      <a-form :form="form">
        <a-form-item label="新的名称" :labelCol="{ sm: 8, md: 5 }" :wrapperCol="{ sm: 16, md: 18 }">
          <a-input
            placeholder="输入终端名称/房间号"
            v-decorator="['deviceName', {
              rules: [{ min: 2, max: 40, required: true, message: '名称限制2-40个字符' }]
            }]"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script>
import { convertToPagination } from '@/utils/util'
import { pageDeviceByClient, updateDeviceName } from '@/api/device'

export default {
  data () {
    return {
      form: this.$form.createForm(this),
      visible: false,
      loading: false,
      confirmLoading: false,
      page: {},
      icoUrl: require('@/assets/icons/tv2.svg'),
      query: {
        deviceName: '',
        prop: '',
        direction: '',
        pageSize: 24,
        pageNumber: 0
      },
      pagination: {
        current: 1,
        defaultPageSize: 24,
        pageSize: 24,
        total: 0,
        onChange: (page) => {
          this.query.pageNumber = page - 1
          this.fetchData()
        }
      },
      editingDevice: null
    }
  },

  mounted () {
    this.fetchData()
  },

  methods: {
    fetchData () {
      this.loading = true
      pageDeviceByClient(this.query).then(response => {
        this.page = response.data
        this.pagination = convertToPagination(this.page, this.pagination)
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        this.loading = false
      })
    },

    handleEdit (item) {
      this.editingDevice = item
      this.visible = true
      this.$nextTick(() => this.form.setFieldsValue({ 'deviceName': item.name }))
    },

    handleOk () {
      this.form.validateFields((err, values) => {
        if (!err) {
          if (this.editingDevice.name === values.deviceName) {
            this.visible = false
            return
          }
          updateDeviceName(this.editingDevice.id, values.deviceName).then(response => {
            this.$message.success(response.msg)
            this.visible = false
            this.fetchData()
          }).catch(err => {
            console.log(err)
          }).finally(() => {
            this.confirmLoading = false
          })
        } else {
          console.log(err)
          this.confirmLoading = false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .edit-name {
    font-size: 14px;
    margin-left: 8px;
    font-weight: 300;
    color: rgba(0, 0, 0, 0.45);
  }

  .edit-name:hover {
    color: #1890ff;
  }
</style>
